import "./candidateForm.scss";

import MaskedInput from "@biproxi/react-text-mask";
import { Field, Formik } from "formik";
import { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";

import {
  codeNumberMask,
  snilsNumberMask
} from "components/Validation/index.js";
import cross from "images/cross.svg";
import plus from "images/plus.svg";
import trash from "images/trash.svg";
import { inject, observer } from "mobx-react";

import FileUploadErrorModal from "components/Modals/FileUploadErrorModal";
import ShowDocument from "components/Modals/ShowDocument";
import moment from "moment";
import FilesInfo from "sharedComponents/FilesInfo";
import Tooltip from "sharedComponents/Tooltip";
import { baseUrl } from "stores/main";
import { fileAccept } from "utils/consts";
import {
  applyInfo,
  showModalErrorType,
  showModalErrorTypeSeveral,
  statusType
} from "utils/functions";
import { getValidationSchema } from "./validationNewCandidate";

import DatePicker from "sharedComponents/DatePicker";
import Input from "sharedComponents/Input";
import PhoneInputField from "sharedComponents/PhoneInputField";

const CandidateForm = ({
  errorAddition,
  errorAdditionFields,
  clearErrorAdditionField,

  setFileUploadErrorModal,
  fileUploadErrorModal,

  sendFile,
  deleteFile,
  setOneCandidateFile,
  addCandidateMinimal,
  isNewCandidate,
  selectedCandidate,
  setSelectedCandidate,

  oneCandidateData,
  oneCandidateFiles,
  setIsNewCandidate,
  setDeleteCandidateModal,
  refreshUserDataCandidate,
  setDocumentUrl,
  statusesTitles,
  refreshCandidateOnVacancy,
  addOneCandidateDataValue,
  setIsCandidateModalOpen,
  getCandidates,
  requiredFiles,
  setDeleteModalMessage,
  getInitialValues,
  requiredFieldsForAdd,
  requiredFieldsForUpdate,

  getApplicationsForCandidate,
  getVacancies_for_candidate,
  setModalShowVacancies,
  setFunc,

  getCandidatesForVacancy,

  ...props
}) => {
  const hasBackendErrors =
    errorAdditionFields && Object.keys(errorAdditionFields).length > 0;
  const [isResident, setIsResident] = useState("resident");
  const [passportFileBlocked, setPassportFileBlocked] = useState(false);
  const [passportFile1Blocked, setPassportFile1Blocked] = useState(false);
  const [snilsFileBlocked, setSnilsFileBlocked] = useState(false);
  const [innFileBlocked, setInnFileBlocked] = useState(false);

  const [registrationFileBlocked, setRegistrationFileBlocked] = useState(false);
  const [registrationFileError, setRegistrationFileError] = useState(null);

  const [migrationFilesBlocked, setMigrationFilesBlocked] = useState(false);
  const [migrationFilesError, setMigrationFilesError] = useState(null);

  const [psychoFilesBlocked, setPsychoFilesBlocked] = useState(false);
  const [psychoFilesError, setPsychoFilesError] = useState(null);

  const [addDocsBlocked, setAddDocsBlocked] = useState(false);
  const [addDocsError, setAddDocsError] = useState(null);

  const [passpError, setPasspError] = useState(null);

  const [openModalDocument, setOpenModalDocument] = useState(false);

  const [personalDataBlocked, setPersonalDataBlocked] = useState(false);
  const [personalDataError, setPersonalDataError] = useState(false);

  const [filesBtnsTouched, setFilesBtnsTouched] = useState(false);

  const passportFields = [];

  const clearErrors = () => {
    setRegistrationFileError(null);
    setMigrationFilesError(null);
    setPsychoFilesError(null);
    setAddDocsError(null);
    setPersonalDataError(null);
    setFilesBtnsTouched(false);
  };

  useEffect(() => {
    if (isNewCandidate && oneCandidateData) {
      addOneCandidateDataValue("vacancies_candidate_id_bring_data", "0");
      addOneCandidateDataValue("vacancies_candidate_active_count", "0");
    }
  }, [oneCandidateData]);

  const path = window.location.pathname;

  const [isCandidateAdded, setIsCandidateAdded] = useState(false);

  return (
    <>
      <Formik
        initialValues={getInitialValues(oneCandidateData)}
        validateOnBlur
        validateOnChange
        validationSchema={getValidationSchema(
          Object.keys(getInitialValues(oneCandidateData)),
          isNewCandidate
            ? requiredFieldsForAdd[isResident]
            : requiredFieldsForUpdate[isResident]
        )}
        enableReinitialize
      >
        {({
          initialValues,
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleReset,
          isValid,
          dirty,
          setFieldValue,
          setFieldTouched,
          isSubmitting
        }) => {
          // при изменении значения поля non_resident
          // изменить значение стейта isResident
          // для того, чтобы динамически менять обязательные поля
          setTimeout(() => {
            values.non_resident === "0"
              ? isResident !== "resident" && setIsResident("resident")
              : isResident !== "non_resident" && setIsResident("non_resident");
          }, 100);

          // обязательные поля, зависящие от значения non_resident
          const requiredFields = isNewCandidate
            ? requiredFieldsForAdd[isResident] || []
            : requiredFieldsForUpdate[isResident] || [];

          // заполнены ли обязательные поля для добавления кандидата
          const areMainFieldsFilled = requiredFieldsForAdd[isResident]
            ? !requiredFieldsForAdd[isResident].every(
              (field) => !!errors[field]
            ) &&
            requiredFieldsForAdd[isResident].every((field) => {
              return values[field];
            })
            : false;

          // заполнены ли обязательные поля для обновления кандидата
          const areRequiredFieldsFilled = requiredFieldsForUpdate[isResident]
            ? !requiredFieldsForUpdate[isResident].every(
              (field) => !!errors[field]
            ) &&
            requiredFieldsForUpdate[isResident].every((field) => {
              if (field === "conviction") return true;
              return values[field];
            })
            : false;

          // проверка на наличие файлов кандидата
          const hasRequiredFiles =
            requiredFiles[isResident] && oneCandidateFiles
              ? requiredFiles[isResident].every(
                (file) => oneCandidateFiles[file] !== -1
              )
              : false;

          const applyDisabled = applyInfo(oneCandidateData, statusesTitles);

          let isDisabled = true;

          if (oneCandidateData && statusesTitles) {
            if (
              statusesTitles[oneCandidateData.status_id] === "Черновик" &&
              areRequiredFieldsFilled &&
              hasRequiredFiles
            ) {
              isDisabled = false;
            }
            if (
              (statusesTitles[oneCandidateData.status_id] === "На проверке" ||
                statusesTitles[oneCandidateData.status_id] === "Согласован") &&
              areRequiredFieldsFilled &&
              hasRequiredFiles
            ) {
              if (
                oneCandidateData.vacancies_candidate_id_bring_data &&
                oneCandidateData.vacancies_candidate_id_bring_data !== "0"
              ) {
                isDisabled = false;
              }
              if (
                oneCandidateData.vacancies_candidate_active_count &&
                oneCandidateData.vacancies_candidate_active_count !== "0"
              ) {
                isDisabled = true;
              } else {
                isDisabled = false;
              }
            }
          }

          const addCandidateEnabled =
            isNewCandidate &&
            areMainFieldsFilled &&
            !requiredFields.some((field) => errors[field]);

          const fileUploadTooltip =
            !areMainFieldsFilled || !selectedCandidate || errorAddition
              ? "Сначала заполните обязательные поля (ФИО, телефон, дата рождения)"
              : undefined;

          return (
            <>
              <Modal
                show={props.show}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                contentClassName="registration-modal-content"
                className="registration-modal"
                dialogClassName="registration-modal-dialog"
                backdrop="static"
              >
                <Modal.Body className="registration">
                  <p className="mb-2">
                    <img
                      src={cross}
                      className="registration-img"
                      onClick={async () => {
                        if (!dirty && !isCandidateAdded) {
                          setIsCandidateModalOpen(false);
                          clearErrors();
                        } else {
                          setDeleteModalMessage(
                            "Данные не сохранятся. Вы уверены, что хотите закрыть окно?"
                          );
                          setDeleteCandidateModal(true);
                          clearErrors();
                          setFunc(function () {
                            handleReset();
                            setIsCandidateAdded(false);
                          });
                        }
                      }}
                      alt=""
                    />
                  </p>
                  <div className="registration-form">
                    <Form>
                      <p className="registration-form-title">
                        {isNewCandidate ? "Регистрация кандидата" : "Кандидат"}
                      </p>

                      {/* Дата создания и id кандидата */}
                      {oneCandidateData ? (
                        <div className="mb-3 d-flex justify-content-between">
                          <div className="d-flex gap-3 flex-wrap">
                            <p className="m-0">
                              Создан:{" "}
                              {oneCandidateData.date_create
                                .split(" ")[0]
                                .split("-")
                                .reverse()
                                .join(".")}
                              ,{" "}
                              {oneCandidateData.date_create
                                .split(" ")[1]
                                .slice(0, 5)}
                            </p>
                            {oneCandidateData.number ? (
                              <p className="m-0">
                                ID: {oneCandidateData.number}
                              </p>
                            ) : null}
                          </div>
                          {statusesTitles && oneCandidateData ? (
                            <p
                              className={`m-0 status status_${statusType(
                                statusesTitles[oneCandidateData.status_id]
                              )}`}
                            >
                              {statusesTitles[oneCandidateData.status_id]}
                            </p>
                          ) : null}
                        </div>
                      ) : null}

                      {/* Комментарий к анкете */}
                      {oneCandidateData &&
                        oneCandidateData.comment &&
                        (statusesTitles[oneCandidateData.status_id] ===
                          "Заблокирован" ||
                          oneCandidateData.vacancies_candidate_id_bring_data) ? (
                        <div className="mb-3 candidate-comment">
                          {oneCandidateData.comment}
                        </div>
                      ) : null}

                      {/* Минимально необходимые поля для добавления кандидата */}
                      <Input
                        name="surname"
                        title="Фамилия"
                        required={requiredFields.includes("surname")}
                      />
                      <Input
                        name="name"
                        title="Имя"
                        required={requiredFields.includes("name")}
                        onBlur={async () => {
                          if (addCandidateEnabled) {
                            // Если все минимально необходимые для добавления кандидата поля заполнены
                            // поля для добавления хранятся тут - requiredFieldAdd
                            // Добавляем кандадидата
                            await addCandidateMinimal(values);
                            setIsCandidateAdded(true);
                          }
                        }}
                      />
                      <Input
                        name="patronymic"
                        title="Отчество"
                        required={requiredFields.includes("patronymic")}
                      />

                      <div className="mb-3 doubleField">
                        <PhoneInputField
                          name="phone"
                          title="Номер телефона"
                          errorFromBackend={
                            errorAdditionFields ? errorAdditionFields.phone : ""
                          }
                          required={requiredFields.includes("phone")}
                          onChange={async () => {
                            clearErrorAdditionField &&
                              clearErrorAdditionField("phone");
                            if (addCandidateEnabled) {
                              // Если все минимально необходимые для добавления кандидата поля заполнены
                              // поля для добавления хранятся тут - requiredFieldAdd
                              // Добавляем кандадидата
                              await addCandidateMinimal(values);
                              setIsCandidateAdded(true);
                            }
                          }}
                        />
                        <Input
                          name="email"
                          title="Электронная почта"
                          placeholder="Email"
                          required={requiredFields.includes("email")}
                          errorFromBackend={
                            errorAdditionFields ? errorAdditionFields.email : ""
                          }
                        />
                      </div>

                      <div className="mb-3">
                        <div className="birthday-container">
                          <DatePicker
                            name="birthday"
                            title="Дата рождения"
                            required={requiredFields.includes("birthday")}
                            errorFromBackend={
                              errorAdditionFields
                                ? errorAdditionFields.birthday
                                : ""
                            }
                            onBlur={async (e) => {
                              handleBlur(e);
                              if (addCandidateEnabled) {
                                // Если все минимально необходимые для добавления кандидата поля заполнены
                                // поля для добавления хранятся тут - requiredFieldAdd
                                // Добавляем кандадидата
                                await addCandidateMinimal(values);
                                setIsCandidateAdded(true);
                              }
                            }}
                          />
                          <div className="age-text">
                            {values.birthday &&
                              values.birthday.split("-")[0].charAt(0) !== "0" &&
                              !errors.birthday
                              ? moment().diff(
                                new Date(values.birthday),
                                "years"
                              ) +
                              " " +
                              (moment()
                                .diff(new Date(values.birthday), "years")
                                .toString()
                                .charAt(1)
                                .match(/1/)
                                ? "год"
                                : moment()
                                  .diff(new Date(values.birthday), "years")
                                  .toString()
                                  .charAt(1)
                                  .match(/[2-4]/)
                                  ? "года"
                                  : "лет")
                              : null}
                          </div>
                        </div>
                      </div>

                      {!areMainFieldsFilled ? (
                        <div className="mb-3">
                          <p className="age-text m-0 age-text_add">
                            Для продолжения добавления кандидата заполните
                            первые 4 обязательных поля
                          </p>
                        </div>
                      ) : null}

                      {/*
                        Если кандидат добавлен (поля выше заполнены и нет ошибок с бэка),
                        Разблокируются поля ниже - для обновления кандидата
                      */}

                      <div className="mb-3 d-flex w-100 gap-3">
                        <Form.Label className="mb-1">Гражданство</Form.Label>
                        <div
                          role="group"
                          aria-labelledby="non_resident-group"
                          className="form-radio-group"
                        >
                          <Form.Group className="d-flex gap-2 align-items-center mb-2">
                            <Field
                              as={Form.Check}
                              type="radio"
                              name="non_resident"
                              id="non_resident_0"
                              value="0"
                              disabled={!areMainFieldsFilled || errorAddition}
                              onChange={(e) => {
                                handleChange(e);

                                // Очистить поля паспорта и регистрации при смене Гражданства
                                if (e.target.checked) {
                                  passportFields.forEach((field) => {
                                    setFieldValue(field, initialValues[field]);
                                  });
                                  setFieldValue(
                                    "registration",
                                    initialValues["registration"]
                                  );
                                }
                              }}
                            />
                            <label htmlFor="non_resident_0">РФ</label>
                          </Form.Group>
                          <Form.Group className="d-flex gap-2 align-items-center">
                            <Field
                              as={Form.Check}
                              type="radio"
                              name="non_resident"
                              id="non_resident_1"
                              value="1"
                              disabled={!areMainFieldsFilled || errorAddition}
                              onChange={(e) => {
                                handleChange(e);

                                // Очистить поля паспорта и регистрации при смене Гражданства
                                if (e.target.checked) {
                                  passportFields.forEach((field) => {
                                    setFieldValue(field, initialValues[field]);
                                  });
                                  setFieldValue(
                                    "registration",
                                    initialValues["registration"]
                                  );
                                }
                              }}
                            />
                            <label htmlFor="non_resident_1">Иностранец</label>
                          </Form.Group>
                        </div>
                      </div>

                      <Input
                        name="birth_place"
                        title="Место рождения"
                        required={requiredFields.includes("birth_place")}
                        disabled={!areMainFieldsFilled || errorAddition}
                      />

                      <Input
                        name="region_of_residence"
                        title="Регион проживания"
                        required={requiredFields.includes(
                          "region_of_residence"
                        )}
                        disabled={!areMainFieldsFilled || errorAddition}
                      />

                      {values.non_resident === "0" ? (
                        <Input
                          name="registration"
                          title="Адрес регистрации"
                          required={requiredFields.includes("registration")}
                          disabled={!areMainFieldsFilled || errorAddition}
                        />
                      ) : (
                        <>
                          <div className="mb-2">
                            <div className="d-flex justify-content-between align-items-center mb-1">
                              <div className="d-flex align-items-center gap-2">
                                <p className="m-0">
                                  Регистрация/Временная регистрация
                                </p>
                                <Tooltip
                                  position="bottom"
                                  text="Лицевая сторона и оборотная"
                                />
                              </div>
                              {oneCandidateFiles &&
                                (oneCandidateFiles.registration1 !== -1 ||
                                  oneCandidateFiles.registration2 !==
                                  -1) ? null : (
                                <div className="information-form__label text-end">
                                  Прикрепите файлы
                                </div>
                              )}
                            </div>
                            <div className="d-flex gap-2 flex-wrap registration-container">
                              <Form.Group>
                                <Form.Control
                                  className="information-placeholder"
                                  type="text"
                                  name="registration"
                                  onChange={handleChange}
                                  onFocus={() =>
                                    setFieldTouched("registration", true)
                                  }
                                  onBlur={handleBlur}
                                  value={values.registration || ""}
                                  isInvalid={
                                    touched.registration && errors.registration
                                  }
                                  disabled={
                                    !areMainFieldsFilled || errorAddition
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.registration}
                                </Form.Control.Feedback>
                                {registrationFileError ? (
                                  <div className="registration-error mb-2">
                                    {registrationFileError}
                                  </div>
                                ) : null}
                              </Form.Group>
                              <div>
                                <div className="d-flex align-items-center gap-2 mb-2">
                                  <label
                                    className={`btn-files w-auto ${!oneCandidateData &&
                                        (!areMainFieldsFilled ||
                                          errorAddition ||
                                          !selectedCandidate ||
                                          registrationFileBlocked)
                                        ? "btn-files_disabled"
                                        : ""
                                      }`}
                                    title={fileUploadTooltip}
                                  >
                                    <input
                                      type="file"
                                      accept={fileAccept}
                                      hidden
                                      multiple
                                      disabled={
                                        !areMainFieldsFilled ||
                                        errorAddition ||
                                        !selectedCandidate ||
                                        registrationFileBlocked
                                      }
                                      onChange={async (e) => {
                                        setRegistrationFileBlocked(true);
                                        const files = e.target.files;
                                        if (files.length > 2) {
                                          setRegistrationFileError(
                                            "Не более 2х файлов"
                                          );
                                          setRegistrationFileBlocked(false);
                                        } else {
                                          await showModalErrorTypeSeveral({
                                            id: selectedCandidate,
                                            name: "registration",
                                            filesToSend: e.target.files,
                                            setFileUploadErrorModal: (val) =>
                                              setFileUploadErrorModal(val),
                                            sendFile: async ({ ...obj }) =>
                                              await sendFile({ ...obj })
                                          });
                                          setFilesBtnsTouched(true);
                                          setFilesBtnsTouched(true);
                                          setRegistrationFileError(null);
                                          setRegistrationFileBlocked(false);
                                        }
                                      }}
                                    />
                                    <img src={plus} alt="" />
                                  </label>
                                  {oneCandidateFiles &&
                                    (oneCandidateFiles.registration1 ||
                                      oneCandidateFiles.registration2) &&
                                    (oneCandidateFiles.registration1 !== -1 ||
                                      oneCandidateFiles.registration2 !== -1) ? (
                                    <div className="files-info-container_mobile mt-2">
                                      <FilesInfo
                                        hasFiles={
                                          oneCandidateFiles.registration1 !==
                                          -1 ||
                                          oneCandidateFiles.registration2 !== -1
                                        }
                                      >
                                        {[
                                          {
                                            file: oneCandidateFiles[
                                              "registration1"
                                            ],
                                            handleClick: () => {
                                              setOpenModalDocument(true);
                                              setDocumentUrl(
                                                `${baseUrl}${oneCandidateFiles[
                                                "registration1"
                                                ]
                                                }?${Date.now()}`
                                              );
                                            }
                                          },
                                          {
                                            file: oneCandidateFiles[
                                              "registration2"
                                            ],
                                            handleClick: () => {
                                              setOpenModalDocument(true);
                                              setDocumentUrl(
                                                `${baseUrl}${oneCandidateFiles[
                                                "registration2"
                                                ]
                                                }?${Date.now()}`
                                              );
                                            }
                                          }
                                        ]}
                                      </FilesInfo>
                                    </div>
                                  ) : (
                                    <div className="information-form__label information-form__label_small text-end">
                                      Прикрепите файлы
                                    </div>
                                  )}
                                </div>
                                {registrationFileError ? (
                                  <div className="registration-error_small mb-2">
                                    {registrationFileError}
                                  </div>
                                ) : null}
                              </div>
                            </div>

                            {oneCandidateFiles &&
                              (oneCandidateFiles.registration1 ||
                                oneCandidateFiles.registration2) &&
                              (oneCandidateFiles.registration1 !== -1 ||
                                oneCandidateFiles.registration2 !== -1) ? (
                              <div className="files-info-container files-info-container_small">
                                <FilesInfo
                                  hasFiles={
                                    oneCandidateFiles.registration1 !== -1 ||
                                    oneCandidateFiles.registration2 !== -1
                                  }
                                >
                                  {[
                                    {
                                      file: oneCandidateFiles["registration1"],
                                      handleClick: () => {
                                        setOpenModalDocument(true);
                                        setDocumentUrl(
                                          `${baseUrl}${oneCandidateFiles["registration1"]
                                          }?${Date.now()}`
                                        );
                                      }
                                    },
                                    {
                                      file: oneCandidateFiles["registration2"],
                                      handleClick: () => {
                                        setOpenModalDocument(true);
                                        setDocumentUrl(
                                          `${baseUrl}${oneCandidateFiles["registration2"]
                                          }?${Date.now()}`
                                        );
                                      }
                                    }
                                  ]}
                                </FilesInfo>
                              </div>
                            ) : null}
                          </div>
                        </>
                      )}

                      <div className="mb-3 d-flex w-100 gap-3">
                        <Form.Label className="mb-1">{`Судимость${requiredFields.includes("conviction") ? "*" : ""
                          }`}</Form.Label>
                        <div
                          role="group"
                          aria-labelledby="conviction-group"
                          className="form-radio-group"
                        >
                          <Form.Group className="d-flex gap-2 align-items-center mb-2">
                            <Field
                              as={Form.Check}
                              type="radio"
                              name="hasConviction"
                              id="conviction_0"
                              value="Нет"
                              disabled={!areMainFieldsFilled || errorAddition}
                              onChange={(event) => {
                                handleChange(event);

                                // При отстутствии судимости, записать в поле conviction - Нет
                                // Для корректной работы валидации
                                if (event.target.checked) {
                                  setFieldValue("conviction", "Нет");

                                  setTimeout(() => {
                                    setFieldTouched("conviction");
                                  }, 100);
                                }
                              }}
                            />
                            <label htmlFor="conviction_0">Нет</label>
                          </Form.Group>
                          <Form.Group className="d-flex gap-2 align-items-center">
                            <Field
                              as={Form.Check}
                              type="radio"
                              name="hasConviction"
                              id="conviction_1"
                              value="Есть"
                              disabled={!areMainFieldsFilled || errorAddition}
                              onChange={(event) => {
                                handleChange(event);

                                // При наличии судимости, очистить поле conviction
                                // Чтобы пользователь увидел ошибку в поле и записал статью осужденного
                                if (event.target.checked) {
                                  setFieldValue("conviction", "");
                                  setTimeout(() => {
                                    setFieldTouched("conviction");
                                  }, 100);
                                }
                              }}
                            />
                            <label htmlFor="conviction_1">Есть</label>
                          </Form.Group>
                        </div>
                      </div>
                      {values.hasConviction === "Есть" ? (
                        <Input
                          name="conviction"
                          placeholder="Напишите, когда и по какой статье привлекались"
                        />
                      ) : null}
                      {values.non_resident === "0" ? (
                        <>
                          <div className="mb-1 d-flex justify-content-between">
                            <div className="align-self-end d-flex gap-3">
                              <Form.Label className="m-0 align-self-end">
                                Паспорт
                              </Form.Label>
                              {oneCandidateFiles &&
                                (oneCandidateFiles.passport !== -1 ||
                                  oneCandidateFiles.passport1 !== -1) ? (
                                <div className="files-info-container files-info-container_small align-self-end">
                                  <FilesInfo
                                    hasFiles={
                                      oneCandidateFiles.passport !== -1 ||
                                      oneCandidateFiles.passport1 !== -1
                                    }
                                  >
                                    {[
                                      {
                                        file: oneCandidateFiles["passport"],
                                        handleClick: () => {
                                          setOpenModalDocument(true);
                                          setDocumentUrl(
                                            `${baseUrl}${oneCandidateFiles["passport"]
                                            }?${Date.now()}`
                                          );
                                        }
                                      },
                                      {
                                        file: oneCandidateFiles["passport1"],
                                        handleClick: () => {
                                          setOpenModalDocument(true);
                                          setDocumentUrl(
                                            `${baseUrl}${oneCandidateFiles["passport1"]
                                            }?${Date.now()}`
                                          );
                                        }
                                      }
                                    ]}
                                  </FilesInfo>
                                </div>
                              ) : null}
                            </div>
                            <div className="d-flex align-items-center">
                              {oneCandidateFiles &&
                                oneCandidateFiles.passport !== -1 &&
                                oneCandidateFiles.passport1 !== -1 ? null : (
                                <div
                                  className={`registration-form-label text-end ${values.non_resident === "0"
                                      ? "registration-form-label_small-red"
                                      : ""
                                    }`}
                                >
                                  Для отклика требуется прикрепить 2 файла
                                </div>
                              )}
                              <Tooltip
                                position="bottom"
                                text="Прикрепите главную страницу паспорта, и страницу с пропиской"
                              />
                            </div>
                          </div>
                          <div className="d-flex mb-2">
                            {false && (
                              <>
                                <Form.Group className="flex-grow-1">
                                  <Form.Control
                                    className="information-placeholder"
                                    type="tel"
                                    name="passport_series"
                                    placeholder="Серия"
                                    value={values.passport_series || ""}
                                    onChange={handleChange}
                                    onFocus={() => {
                                      for (const field of passportFields) {
                                        setFieldTouched(field, true);
                                      }
                                    }}
                                    onBlur={handleBlur}
                                    isInvalid={
                                      touched.passport_series &&
                                      errors.passport_series
                                    }
                                    disabled={
                                      !areMainFieldsFilled || errorAddition
                                    }
                                  />
                                  {errors.passport_series &&
                                    !errors.passport_series
                                      .charAt(0)
                                      .match(/з/gi) && (
                                      <Form.Control.Feedback type="invalid">
                                        {errors.passport_series}
                                      </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                                <Form.Group className="flex-grow-1">
                                  <Form.Control
                                    className="information-placeholder"
                                    type="tel"
                                    name="passport_number"
                                    placeholder="Номер"
                                    value={values.passport_number || ""}
                                    onChange={handleChange}
                                    onFocus={() => {
                                      for (const field of passportFields) {
                                        setFieldTouched(field, true);
                                      }
                                    }}
                                    onBlur={handleBlur}
                                    isInvalid={
                                      touched.passport_number &&
                                      errors.passport_number
                                    }
                                    disabled={
                                      !areMainFieldsFilled || errorAddition
                                    }
                                  />
                                  {errors.passport_number &&
                                    !errors.passport_number
                                      .charAt(0)
                                      .match(/з/gi) && (
                                      <Form.Control.Feedback type="invalid">
                                        {errors.passport_number}
                                      </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                              </>
                            )}
                            <label
                              className={`btn-files w-auto ${!areMainFieldsFilled ||
                                  errorAddition ||
                                  !selectedCandidate ||
                                  passportFileBlocked
                                  ? "btn-files_disabled"
                                  : ""
                                }`}
                              title={fileUploadTooltip}
                            >
                              <input
                                type="file"
                                accept={fileAccept}
                                hidden
                                disabled={
                                  !areMainFieldsFilled ||
                                  errorAddition ||
                                  !selectedCandidate ||
                                  passportFileBlocked
                                }
                                onChange={async (e) => {
                                  setPassportFileBlocked(true);
                                  await showModalErrorType({
                                    id: selectedCandidate,
                                    file: e.target.files[0],
                                    file_name: "passport",
                                    setFileUploadErrorModal: (val) =>
                                      setFileUploadErrorModal(val),
                                    sendFile: async ({ ...obj }) => {
                                      await sendFile({ ...obj });
                                    }
                                  });
                                  setFilesBtnsTouched(true);
                                  setPassportFileBlocked(false);
                                }}
                              />
                              <img src={plus} alt="" />
                            </label>
                          </div>
                          <div className="d-flex mb-2">
                            {false && (
                              <Form.Group className="flex-grow-1">
                                <Form.Control
                                  className="information-placeholder"
                                  type="text"
                                  name="passport_propiska"
                                  placeholder="Адрес прописки"
                                  onChange={handleChange}
                                  onFocus={() => {
                                    for (const field of passportFields) {
                                      setFieldTouched(field, true);
                                    }
                                  }}
                                  onBlur={handleBlur}
                                  value={values.passport_propiska || ""}
                                  isInvalid={
                                    touched.passport_propiska &&
                                    errors.passport_propiska
                                  }
                                  disabled={
                                    !areMainFieldsFilled || errorAddition
                                  }
                                />
                                {errors.passport_propiska &&
                                  !errors.passport_propiska
                                    .charAt(0)
                                    .match(/з/gi) && (
                                    <Form.Control.Feedback type="invalid">
                                      {errors.passport_propiska}
                                    </Form.Control.Feedback>
                                  )}
                              </Form.Group>
                            )}
                            <label
                              className={`btn-files w-auto ${!areMainFieldsFilled ||
                                  errorAddition ||
                                  passportFile1Blocked
                                  ? "btn-files_disabled"
                                  : ""
                                }`}
                            >
                              <input
                                type="file"
                                accept={fileAccept}
                                hidden
                                disabled={
                                  !areMainFieldsFilled ||
                                  errorAddition ||
                                  passportFile1Blocked
                                }
                                onChange={async (e) => {
                                  setPassportFile1Blocked(true);
                                  await showModalErrorType({
                                    id: selectedCandidate,
                                    file: e.target.files[0],
                                    file_name: "passport1",
                                    setFileUploadErrorModal: (val) =>
                                      setFileUploadErrorModal(val),
                                    sendFile: async ({ ...obj }) =>
                                      await sendFile({ ...obj })
                                  });
                                  setFilesBtnsTouched(true);
                                  setPassportFile1Blocked(false);
                                }}
                              />
                              <img src={plus} alt="" />
                            </label>
                          </div>
                          {false && (
                            <>
                              <div className="d-flex mb-2">
                                <Form.Group className="passport-date-container">
                                  <Form.Control
                                    type={
                                      values.passport_date ? "date" : "text"
                                    }
                                    className="passport-date"
                                    max="2999-12-31"
                                    placeholder="Дата выдачи"
                                    name="passport_date"
                                    onChange={handleChange}
                                    onFocus={(e) => {
                                      if (e.target.type !== "date") {
                                        e.target.type = "date";
                                      }
                                      for (const field of passportFields) {
                                        setFieldTouched(field, true);
                                      }
                                    }}
                                    onBlur={(e) => {
                                      handleBlur(e);
                                      if (!e.target.value) {
                                        e.target.type = "text";
                                      }
                                    }}
                                    value={values.passport_date || ""}
                                    isInvalid={
                                      touched.passport_date &&
                                      errors.passport_date
                                    }
                                    disabled={
                                      !areMainFieldsFilled || errorAddition
                                    }
                                  />
                                  {errors.passport_date &&
                                    !errors.passport_date
                                      .charAt(0)
                                      .match(/з/gi) && (
                                      <Form.Control.Feedback type="invalid">
                                        {errors.passport_date}
                                      </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                                <Form.Group className="flex-grow-1">
                                  <Field name="passport_code">
                                    {({ field }) => (
                                      <MaskedInput
                                        {...field}
                                        mask={codeNumberMask}
                                        placeholder="Код подразделения"
                                        type="text"
                                        onChange={handleChange}
                                        onFocus={() => {
                                          for (const field of passportFields) {
                                            setFieldTouched(field, true);
                                          }
                                        }}
                                        onBlur={handleBlur}
                                        className={`information-placeholder ${touched.passport_code &&
                                            errors.passport_code
                                            ? "form-control is-invalid"
                                            : "form-control"
                                          }`}
                                        disabled={
                                          !areMainFieldsFilled || errorAddition
                                        }
                                      />
                                    )}
                                  </Field>
                                  {errors.passport_code &&
                                    !errors.passport_code
                                      .charAt(0)
                                      .match(/з/gi) && (
                                      <Form.Control.Feedback type="invalid">
                                        {errors.passport_code}
                                      </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                              </div>
                              <Form.Group className="mb-3">
                                <Form.Control
                                  className="information-placeholder"
                                  name="passport_place"
                                  placeholder="Кем выдан"
                                  value={values.passport_place || ""}
                                  onChange={handleChange}
                                  onFocus={() => {
                                    for (const field of passportFields) {
                                      setFieldTouched(field, true);
                                    }
                                  }}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    touched.passport_place &&
                                    errors.passport_place
                                  }
                                  disabled={
                                    !areMainFieldsFilled || errorAddition
                                  }
                                />
                              </Form.Group>
                            </>
                          )}

                          {oneCandidateFiles &&
                            (oneCandidateFiles.passport !== -1 ||
                              oneCandidateFiles.passport1 !== -1) ? (
                            <div className="files-info-container files-info-container_mobile align-self-end">
                              <FilesInfo
                                hasFiles={
                                  oneCandidateFiles.passport !== -1 ||
                                  oneCandidateFiles.passport1 !== -1
                                }
                              >
                                {[
                                  {
                                    file: oneCandidateFiles["passport"],
                                    handleClick: () => {
                                      setOpenModalDocument(true);
                                      setDocumentUrl(
                                        `${baseUrl}${oneCandidateFiles["passport"]}`
                                      );
                                    }
                                  },
                                  {
                                    file: oneCandidateFiles["passport1"],
                                    handleClick: () => {
                                      setOpenModalDocument(true);
                                      setDocumentUrl(
                                        `${baseUrl}${oneCandidateFiles["passport1"]}`
                                      );
                                    }
                                  }
                                ]}
                              </FilesInfo>
                            </div>
                          ) : null}
                        </>
                      ) : (
                        <>
                          <div className="mb-3">
                            <div className="d-flex gap-2 align-items-center mb-1">
                              <p className="m-0">ВНЖ или Миграционная карта*</p>
                              <Tooltip
                                position="bottom-center"
                                text="В данное поле нужно добавить один из документов: ВНЖ или Миграционную карту"
                              />
                            </div>
                            <div className="d-flex gap-2 align-items-center">
                              <label
                                className={`btn-files w-auto ${!areMainFieldsFilled ||
                                    errorAddition ||
                                    !selectedCandidate ||
                                    migrationFilesBlocked
                                    ? "btn-files_disabled"
                                    : ""
                                  }`}
                                title={fileUploadTooltip}
                              >
                                <input
                                  type="file"
                                  accept={fileAccept}
                                  hidden
                                  multiple
                                  disabled={
                                    !areMainFieldsFilled ||
                                    errorAddition ||
                                    !selectedCandidate ||
                                    migrationFilesBlocked
                                  }
                                  onChange={async (e) => {
                                    setMigrationFilesBlocked(true);
                                    setMigrationFilesError(null);
                                    const files = e.target.files;
                                    if (files.length > 2) {
                                      setMigrationFilesError(
                                        "Не более 2х файлов"
                                      );
                                      setMigrationFilesBlocked(false);
                                    } else {
                                      await showModalErrorTypeSeveral({
                                        id: selectedCandidate,
                                        name: "migration_card",
                                        filesToSend: e.target.files,
                                        setFileUploadErrorModal: (val) =>
                                          setFileUploadErrorModal(val),
                                        sendFile: async ({ ...obj }) =>
                                          await sendFile({ ...obj })
                                      });
                                      setFilesBtnsTouched(true);
                                      setMigrationFilesError(null);
                                      setMigrationFilesBlocked(false);
                                    }
                                  }}
                                />
                                <img src={plus} alt="" />
                              </label>
                              {oneCandidateFiles &&
                                (oneCandidateFiles.migration_card1 ||
                                  oneCandidateFiles.migration_card2) &&
                                (oneCandidateFiles.migration_card1 !== -1 ||
                                  oneCandidateFiles.migration_card2 !== -1) ? (
                                <div className="files-info-container">
                                  <FilesInfo
                                    hasFiles={
                                      oneCandidateFiles.migration_card1 !==
                                      -1 ||
                                      oneCandidateFiles.migration_card2 !== -1
                                    }
                                  >
                                    {[
                                      {
                                        file: oneCandidateFiles[
                                          "migration_card1"
                                        ],
                                        handleClick: () => {
                                          setOpenModalDocument(true);
                                          setDocumentUrl(
                                            `${baseUrl}${oneCandidateFiles[
                                            "migration_card1"
                                            ]
                                            }?${Date.now()}`
                                          );
                                        }
                                      },
                                      {
                                        file: oneCandidateFiles[
                                          "migration_card2"
                                        ],
                                        handleClick: () => {
                                          setOpenModalDocument(true);
                                          setDocumentUrl(
                                            `${baseUrl}${oneCandidateFiles[
                                            "migration_card2"
                                            ]
                                            }?${Date.now()}`
                                          );
                                        }
                                      }
                                    ]}
                                  </FilesInfo>
                                </div>
                              ) : (
                                <div className="information-form__label information-form__label_red text-end">
                                  Для отклика требуется прикрепить файлы
                                </div>
                              )}
                            </div>
                            {migrationFilesError ? (
                              <div className="upload-files-error mt-2">
                                {migrationFilesError}
                              </div>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <div className="d-flex gap-2 align-items-center mb-1">
                              <p className="m-0">
                                Дактилоскопия / Справка психо-нарко*
                              </p>
                              <Tooltip
                                position="bottom-center"
                                text="В данное поле нужно прикрепить Дактилоскопию, в случае отсутствия данного документа нужно прикрепить 2 документа: Справка от психиатра и Справка от нарколога "
                              />
                            </div>
                            <div className="d-flex gap-2 align-items-center">
                              <label
                                className={`btn-files w-auto ${!areMainFieldsFilled ||
                                    errorAddition ||
                                    !selectedCandidate ||
                                    psychoFilesBlocked
                                    ? "btn-files_disabled"
                                    : ""
                                  }`}
                                title={fileUploadTooltip}
                              >
                                <input
                                  type="file"
                                  accept={fileAccept}
                                  hidden
                                  multiple
                                  disabled={
                                    !areMainFieldsFilled ||
                                    errorAddition ||
                                    !selectedCandidate ||
                                    psychoFilesBlocked
                                  }
                                  onChange={async (e) => {
                                    setPsychoFilesBlocked(true);
                                    setPsychoFilesError(null);
                                    const files = e.target.files;
                                    if (files.length > 2) {
                                      setPsychoFilesError("Не более 2х файлов");
                                      setPsychoFilesBlocked(false);
                                    } else {
                                      await showModalErrorTypeSeveral({
                                        id: selectedCandidate,
                                        name: "psychiatrist_reference",
                                        filesToSend: e.target.files,
                                        setFileUploadErrorModal: (val) =>
                                          setFileUploadErrorModal(val),
                                        sendFile: async ({ ...obj }) =>
                                          await sendFile({ ...obj })
                                      });
                                      setFilesBtnsTouched(true);
                                      setPsychoFilesError(null);
                                      setPsychoFilesBlocked(false);
                                    }
                                  }}
                                />
                                <img src={plus} alt="" />
                              </label>
                              {oneCandidateFiles &&
                                (oneCandidateFiles.psychiatrist_reference1 ||
                                  oneCandidateFiles.psychiatrist_reference2) &&
                                (oneCandidateFiles.psychiatrist_reference1 !==
                                  -1 ||
                                  oneCandidateFiles.psychiatrist_reference2 !==
                                  -1) ? (
                                <div className="files-info-container">
                                  <FilesInfo
                                    hasFiles={
                                      oneCandidateFiles.psychiatrist_reference1 !==
                                      -1 ||
                                      oneCandidateFiles.psychiatrist_reference2 !==
                                      -1
                                    }
                                  >
                                    {[
                                      {
                                        file: oneCandidateFiles[
                                          "psychiatrist_reference1"
                                        ],
                                        handleClick: () => {
                                          setOpenModalDocument(true);
                                          setDocumentUrl(
                                            `${baseUrl}${oneCandidateFiles[
                                            "psychiatrist_reference1"
                                            ]
                                            }?${Date.now()}`
                                          );
                                        }
                                      },
                                      {
                                        file: oneCandidateFiles[
                                          "psychiatrist_reference2"
                                        ],
                                        handleClick: () => {
                                          setOpenModalDocument(true);
                                          setDocumentUrl(
                                            `${baseUrl}${oneCandidateFiles[
                                            "psychiatrist_reference2"
                                            ]
                                            }?${Date.now()}`
                                          );
                                        }
                                      }
                                    ]}
                                  </FilesInfo>
                                </div>
                              ) : (
                                <div className="information-form__label information-form__label_red text-end">
                                  Для отклика требуется прикрепить файлы
                                </div>
                              )}
                            </div>
                            {psychoFilesError ? (
                              <div className="upload-files-error mt-2">
                                {psychoFilesError}
                              </div>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <div className="d-flex gap-2 align-items-center mb-1">
                              <p className="m-0">Паспорт</p>
                              <Tooltip text="Прикрепите главную страницу паспорта, и страницу с пропиской" />
                            </div>
                            <div className="d-flex gap-2 align-items-center">
                              <label
                                className={`btn-files w-auto ${!areMainFieldsFilled ||
                                    errorAddition ||
                                    !selectedCandidate ||
                                    passportFileBlocked
                                    ? "btn-files_disabled"
                                    : ""
                                  }`}
                                title={fileUploadTooltip}
                              >
                                <input
                                  type="file"
                                  accept={fileAccept}
                                  hidden
                                  disabled={
                                    !areMainFieldsFilled ||
                                    errorAddition ||
                                    !selectedCandidate ||
                                    passportFileBlocked
                                  }
                                  multiple
                                  onChange={async (e) => {
                                    setPassportFileBlocked(true);
                                    setPasspError(null);
                                    const files = e.target.files;
                                    if (files.length > 2) {
                                      setPasspError("Не более 2х файлов");
                                      setPassportFileBlocked(false);
                                    } else if (files.length === 1) {
                                      await showModalErrorType({
                                        id: selectedCandidate,
                                        file: files[0],
                                        file_name: "passport",
                                        setFileUploadErrorModal: (val) =>
                                          setFileUploadErrorModal(val),
                                        sendFile: async ({ ...obj }) =>
                                          await sendFile({ ...obj })
                                      });
                                      setFilesBtnsTouched(true);
                                      setPasspError(null);
                                      setPassportFileBlocked(false);
                                    } else {
                                      await Promise.all([
                                        showModalErrorType({
                                          id: selectedCandidate,
                                          file: files[0],
                                          file_name: "passport",
                                          setFileUploadErrorModal: (val) =>
                                            setFileUploadErrorModal(val),
                                          sendFile: async ({ ...obj }) =>
                                            await sendFile({ ...obj })
                                        }),
                                        showModalErrorType({
                                          id: selectedCandidate,
                                          file: files[1],
                                          file_name: "passport1",
                                          setFileUploadErrorModal: (val) =>
                                            setFileUploadErrorModal(val),
                                          sendFile: async ({ ...obj }) =>
                                            await sendFile({ ...obj })
                                        })
                                      ]);
                                      setFilesBtnsTouched(true);
                                      setPasspError(null);
                                      setPassportFileBlocked(false);
                                    }
                                  }}
                                />
                                <img src={plus} alt="" />
                              </label>
                              {oneCandidateFiles &&
                                (oneCandidateFiles.passport ||
                                  oneCandidateFiles.passport1) &&
                                (oneCandidateFiles.passport !== -1 ||
                                  oneCandidateFiles.passport1 !== -1) ? (
                                <div className="files-info-container">
                                  <FilesInfo
                                    hasFiles={
                                      oneCandidateFiles.passport !== -1 ||
                                      oneCandidateFiles.passport1 !== -1
                                    }
                                  >
                                    {[
                                      {
                                        file: oneCandidateFiles["passport"],
                                        handleClick: () => {
                                          setOpenModalDocument(true);
                                          setDocumentUrl(
                                            `${baseUrl}${oneCandidateFiles["passport"]
                                            }?${Date.now()}`
                                          );
                                        }
                                      },
                                      {
                                        file: oneCandidateFiles["passport1"],
                                        handleClick: () => {
                                          setOpenModalDocument(true);
                                          setDocumentUrl(
                                            `${baseUrl}${oneCandidateFiles["passport1"]
                                            }?${Date.now()}`
                                          );
                                        }
                                      }
                                    ]}
                                  </FilesInfo>
                                </div>
                              ) : (
                                <div className="registration-form-label text-end">
                                  Прикрепите файлы
                                </div>
                              )}
                            </div>
                            {passpError ? (
                              <div className="upload-files-error mt-2">
                                {passpError}
                              </div>
                            ) : null}
                          </div>
                        </>
                      )}
                      <div className="mb-3">
                        <div className="d-flex justify-content-between">
                          <div className="mb-1 d-flex gap-3">
                            <Form.Label className="mb-0 align-self-end">
                              СНИЛС
                            </Form.Label>
                            {oneCandidateFiles &&
                              oneCandidateFiles.snils !== -1 ? (
                              <div className="files-info-container files-info-container_small align-self-end">
                                <FilesInfo
                                  hasFiles={oneCandidateFiles.snils !== -1}
                                >
                                  {[
                                    {
                                      file: oneCandidateFiles["snils"],
                                      handleClick: () => {
                                        setOpenModalDocument(true);
                                        setDocumentUrl(
                                          `${baseUrl}${oneCandidateFiles["snils"]
                                          }?${Date.now()}`
                                        );
                                      }
                                    }
                                  ]}
                                </FilesInfo>
                              </div>
                            ) : null}
                          </div>
                          {oneCandidateFiles &&
                            oneCandidateFiles.snils !== -1 ? null : (
                            <div
                              className={`information-form__label text-end ${values.non_resident === "0"
                                  ? "information-form__label_red"
                                  : ""
                                }`}
                            >
                              {values.non_resident === "0"
                                ? "Для отклика требуется прикрепить файлы"
                                : "Прикрепите файл"}
                            </div>
                          )}
                        </div>
                        <div className="d-flex">
                          {false && (
                            <Form.Group>
                              <Field name="snils">
                                {({ field }) => (
                                  <MaskedInput
                                    {...field}
                                    mask={snilsNumberMask}
                                    placeholder="000-000-000 00"
                                    value={values.snils || ""}
                                    type="text"
                                    onChange={handleChange}
                                    onFocus={() =>
                                      setFieldTouched("snils", true)
                                    }
                                    onBlur={handleBlur}
                                    className={`information-placeholder ${errors.snils && touched.snils
                                        ? "form-control is-invalid"
                                        : "form-control"
                                      }`}
                                    disabled={
                                      !areMainFieldsFilled || errorAddition
                                    }
                                  />
                                )}
                              </Field>
                              <Form.Control.Feedback type="invalid">
                                {errors.snils}
                              </Form.Control.Feedback>
                            </Form.Group>
                          )}
                          <div className="align-self-start">
                            <label
                              className={`btn-files w-auto ${!areMainFieldsFilled ||
                                  errorAddition ||
                                  !selectedCandidate ||
                                  snilsFileBlocked
                                  ? "btn-files_disabled"
                                  : ""
                                }`}
                              title={fileUploadTooltip}
                            >
                              <input
                                type="file"
                                accept={fileAccept}
                                hidden
                                disabled={
                                  !areMainFieldsFilled ||
                                  errorAddition ||
                                  !selectedCandidate ||
                                  snilsFileBlocked
                                }
                                onChange={async (e) => {
                                  setSnilsFileBlocked(true);

                                  await showModalErrorType({
                                    id: selectedCandidate,
                                    file: e.target.files[0],
                                    file_name: "snils",
                                    setFileUploadErrorModal: (val) =>
                                      setFileUploadErrorModal(val),
                                    sendFile: async ({ ...obj }) => {
                                      await sendFile({ ...obj });
                                    }
                                  });
                                  setFilesBtnsTouched(true);

                                  setSnilsFileBlocked(false);
                                }}
                              />
                              <img src={plus} alt="" />
                            </label>
                          </div>
                          {oneCandidateFiles &&
                            oneCandidateFiles.snils !== -1 ? (
                            <div className="files-info-container files-info-container_mobile align-self-start mb-2">
                              <FilesInfo
                                hasFiles={oneCandidateFiles.snils !== -1}
                              >
                                {[
                                  {
                                    file: oneCandidateFiles["snils"],
                                    handleClick: () => {
                                      setOpenModalDocument(true);
                                      setDocumentUrl(
                                        `${baseUrl}${oneCandidateFiles["snils"]
                                        }?${Date.now()}`
                                      );
                                    }
                                  }
                                ]}
                              </FilesInfo>
                            </div>
                          ) : (
                            <div
                              className={`registration-form-label_small ${values.non_resident === "0"
                                  ? "registration-form-label_small-red"
                                  : ""
                                }`}
                            >
                              {" "}
                              {values.non_resident === "0"
                                ? "Для отклика требуется прикрепить файлы"
                                : "Прикрепите файл"}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="mb-3">
                        <div className="d-flex justify-content-between">
                          <div className="mb-1 d-flex gap-3">
                            <Form.Label className="mb-0 align-self-end">
                              ИНН
                            </Form.Label>
                            {oneCandidateFiles &&
                              oneCandidateFiles.inn !== -1 ? (
                              <div className="files-info-container files-info-container_small align-self-end">
                                <FilesInfo
                                  hasFiles={oneCandidateFiles.inn !== -1}
                                >
                                  {[
                                    {
                                      file: oneCandidateFiles["inn"],
                                      handleClick: () => {
                                        setOpenModalDocument(true);
                                        setDocumentUrl(
                                          `${baseUrl}${oneCandidateFiles["inn"]
                                          }?${Date.now()}`
                                        );
                                      }
                                    }
                                  ]}
                                </FilesInfo>
                              </div>
                            ) : null}
                          </div>
                          {oneCandidateFiles &&
                            oneCandidateFiles.inn !== -1 ? null : (
                            <div
                              className={`information-form__label text-end ${values.non_resident === "0"
                                  ? "information-form__label_red"
                                  : ""
                                }`}
                            >
                              {values.non_resident === "0"
                                ? "Для отклика требуется прикрепить файлы"
                                : "Прикрепите файл"}
                            </div>
                          )}
                        </div>
                        <div className="d-flex">
                          {false && (
                            <Form.Group>
                              <Form.Control
                                className="information-placeholder"
                                type="tel"
                                placeholder="12-значный номер"
                                name="inn"
                                value={values.inn || ""}
                                onChange={handleChange}
                                onFocus={() => setFieldTouched("inn", true)}
                                onBlur={handleBlur}
                                isInvalid={touched.inn && errors.inn}
                                disabled={!areMainFieldsFilled || errorAddition}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.inn}
                              </Form.Control.Feedback>
                            </Form.Group>
                          )}
                          <div className="align-self-start">
                            <label
                              className={`btn-files w-auto ${!areMainFieldsFilled ||
                                  errorAddition ||
                                  !selectedCandidate ||
                                  innFileBlocked
                                  ? "btn-files_disabled"
                                  : ""
                                }`}
                              title={fileUploadTooltip}
                            >
                              <input
                                type="file"
                                accept={fileAccept}
                                hidden
                                disabled={
                                  !areMainFieldsFilled ||
                                  errorAddition ||
                                  !selectedCandidate ||
                                  innFileBlocked
                                }
                                onChange={async (e) => {
                                  setInnFileBlocked(true);
                                  await showModalErrorType({
                                    id: selectedCandidate,
                                    file: e.target.files[0],
                                    file_name: "inn",
                                    setFileUploadErrorModal: (val) =>
                                      setFileUploadErrorModal(val),
                                    sendFile: async ({ ...obj }) => {
                                      await sendFile({ ...obj });
                                    }
                                  });
                                  setFilesBtnsTouched(true);
                                  setInnFileBlocked(false);
                                }}
                              />
                              <img src={plus} alt="" />
                            </label>
                          </div>
                          {oneCandidateFiles && oneCandidateFiles.inn !== -1 ? (
                            <div className="files-info-container files-info-container_mobile align-self-start mb-2">
                              <FilesInfo
                                hasFiles={oneCandidateFiles.inn !== -1}
                              >
                                {[
                                  {
                                    file: oneCandidateFiles["inn"],
                                    handleClick: () => {
                                      setOpenModalDocument(true);
                                      setDocumentUrl(
                                        `${baseUrl}${oneCandidateFiles["inn"]
                                        }?${Date.now()}`
                                      );
                                    }
                                  }
                                ]}
                              </FilesInfo>
                            </div>
                          ) : (
                            <div
                              className={`registration-form-label_small ${values.non_resident === "0"
                                  ? "registration-form-label_small-red"
                                  : ""
                                }`}
                            >
                              {" "}
                              {values.non_resident === "0"
                                ? "Для отклика требуется прикрепить файлы"
                                : "Прикрепите файл"}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="mb-3">
                        <div className="d-flex align-items-center mb-1 gap-2">
                          <p
                            className="personal-data m-0"
                            onClick={() => {
                              setDocumentUrl(false);
                              setOpenModalDocument(true);
                            }}
                          >
                            Согласие на обработку персональных данных
                          </p>
                          <Tooltip
                            position="bottom"
                            text="Прикрепите документ с подписью кандидата"
                          />
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <label
                            className={`btn-files w-auto ${!areMainFieldsFilled ||
                                errorAddition ||
                                !selectedCandidate ||
                                personalDataBlocked
                                ? "btn-files_disabled"
                                : ""
                              }`}
                            title={fileUploadTooltip}
                          >
                            <input
                              type="file"
                              accept={fileAccept}
                              hidden
                              multiple
                              disabled={
                                !areMainFieldsFilled ||
                                errorAddition ||
                                !selectedCandidate ||
                                personalDataBlocked
                              }
                              onChange={async (e) => {
                                setPersonalDataBlocked(true);
                                setPersonalDataError(null);
                                const files = e.target.files;
                                if (files.length > 2) {
                                  setPersonalDataError("Не более 2х файлов");
                                  setPersonalDataBlocked(false);
                                } else if (files.length === 1) {
                                  await showModalErrorType({
                                    id: selectedCandidate,
                                    file: files[0],
                                    file_name: "personal_data1",
                                    setFileUploadErrorModal: (val) =>
                                      setFileUploadErrorModal(val),
                                    sendFile: async ({ ...obj }) =>
                                      await sendFile({ ...obj })
                                  });
                                  setFilesBtnsTouched(true);
                                  setPersonalDataError(null);
                                  setPersonalDataBlocked(false);
                                } else {
                                  await Promise.all([
                                    showModalErrorType({
                                      id: selectedCandidate,
                                      file: files[0],
                                      file_name: "personal_data1",
                                      setFileUploadErrorModal: (val) =>
                                        setFileUploadErrorModal(val),
                                      sendFile: async ({ ...obj }) =>
                                        await sendFile({ ...obj })
                                    }),
                                    showModalErrorType({
                                      id: selectedCandidate,
                                      file: files[1],
                                      file_name: "personal_data2",
                                      setFileUploadErrorModal: (val) =>
                                        setFileUploadErrorModal(val),
                                      sendFile: async ({ ...obj }) =>
                                        await sendFile({ ...obj })
                                    })
                                  ]);
                                  setFilesBtnsTouched(true);
                                  setPersonalDataError(null);
                                  setPersonalDataBlocked(false);
                                }
                              }}
                            />
                            <img src={plus} alt="" />
                          </label>
                          {oneCandidateFiles &&
                            (oneCandidateFiles.personal_data1 !== -1 ||
                              oneCandidateFiles.personal_data2 !== -1) ? (
                            <div className="files-info-container align-self-end mb-2">
                              <FilesInfo
                                hasFiles={
                                  oneCandidateFiles.personal_data1 !== -1 ||
                                  oneCandidateFiles.personal_data2 !== -1
                                }
                              >
                                {[
                                  {
                                    file: oneCandidateFiles["personal_data1"],
                                    handleClick: () => {
                                      setOpenModalDocument(true);
                                      setDocumentUrl(
                                        `${baseUrl}${oneCandidateFiles["personal_data1"]
                                        }?${Date.now()}`
                                      );
                                    }
                                  },
                                  {
                                    file: oneCandidateFiles["personal_data2"],
                                    handleClick: () => {
                                      setOpenModalDocument(true);
                                      setDocumentUrl(
                                        `${baseUrl}${oneCandidateFiles["personal_data2"]
                                        }?${Date.now()}`
                                      );
                                    }
                                  }
                                ]}
                              </FilesInfo>
                            </div>
                          ) : (
                            <div className="registration-form-label">
                              Прикрепите файлы
                            </div>
                          )}
                        </div>
                        {personalDataError ? (
                          <div className="addDocs-error mb-3 mt-2">
                            {personalDataError}
                          </div>
                        ) : null}
                      </div>

                      <div>
                        <div className="d-flex align-items-center gap-2 mb-1">
                          <p className="m-0">Дополнительные документы</p>
                          <Tooltip
                            position="bottom-center"
                            text="Можно прикрепить до 5 дополнительных документов        "
                          />
                        </div>
                        <div>
                          <div className="d-flex align-items-center gap-2 mb-3">
                            <label
                              className={`btn-files w-auto ${!areMainFieldsFilled ||
                                  errorAddition ||
                                  !selectedCandidate ||
                                  addDocsBlocked
                                  ? "btn-files_disabled"
                                  : ""
                                }`}
                              title={fileUploadTooltip}
                            >
                              <input
                                type="file"
                                accept={fileAccept}
                                hidden
                                multiple
                                disabled={
                                  !areMainFieldsFilled ||
                                  errorAddition ||
                                  !selectedCandidate ||
                                  addDocsBlocked
                                }
                                onChange={async (e) => {
                                  setAddDocsBlocked(true);
                                  setAddDocsError(null);

                                  const files = e.target.files;

                                  const currentFilesLength = [2, 3, 4, 5, 6]
                                    .map((num) => `passport${num}`)
                                    .map(
                                      (key) =>
                                        oneCandidateFiles &&
                                        oneCandidateFiles[key] &&
                                        oneCandidateFiles[key] !== -1
                                    )
                                    .filter(Boolean).length;

                                  const remainingSlots = 5 - currentFilesLength;

                                  if (files.length > remainingSlots) {
                                    setAddDocsError("Не более 5 файлов");
                                    setAddDocsBlocked(false);
                                    return;
                                  }

                                  const startIdx = currentFilesLength + 2;

                                  await showModalErrorTypeSeveral({
                                    id: selectedCandidate,
                                    name: "passport",
                                    filesToSend: files,
                                    idx: startIdx,
                                    setFileUploadErrorModal: (val) =>
                                      setFileUploadErrorModal(val),
                                    sendFile: async ({ ...obj }) => {
                                      await sendFile({ ...obj });
                                    }
                                  });

                                  setFilesBtnsTouched(true);
                                  setAddDocsBlocked(false);
                                }}
                              />
                              <img src={plus} alt="" />
                            </label>
                            {oneCandidateFiles &&
                              [2, 3, 4, 5, 6]
                                .map((num) => `passport${num}`)
                                .some(
                                  (val) =>
                                    oneCandidateFiles[val] &&
                                    oneCandidateFiles[val] !== -1
                                ) ? (
                              <div>
                                <FilesInfo
                                  hasFiles={[2, 3, 4, 5, 6]
                                    .map((num) => `passport${num}`)
                                    .some(
                                      (val) =>
                                        oneCandidateFiles[val] &&
                                        oneCandidateFiles[val] !== -1
                                    )}
                                >
                                  {[2, 3, 4, 5, 6]
                                    .map((num) => `passport${num}`)
                                    .map((val) => {
                                      return {
                                        file: oneCandidateFiles[val],
                                        handleClick: () => {
                                          setOpenModalDocument(true);
                                          setDocumentUrl(
                                            `${baseUrl}${oneCandidateFiles[val]
                                            }?${Date.now()}`
                                          );
                                        },
                                        handleDelete: async () => {
                                          await deleteFile({
                                            id: selectedCandidate,
                                            file_name: val
                                          });
                                          setOneCandidateFile(val, -1);
                                        }
                                      };
                                    })}
                                </FilesInfo>
                              </div>
                            ) : (
                              <div className="registration-form-label">
                                Прикрепите файлы
                              </div>
                            )}
                          </div>
                          {addDocsError ? (
                            <div className="addDocs-error mb-3">
                              {addDocsError}
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div className="candidate-form-btns d-flex gap-2 flex-wrap position-relative">
                        <button
                          type="button"
                          className="btn-trash"
                          disabled={
                            oneCandidateData && oneCandidateData.moderated !== 0
                          }
                          onClick={() => {
                            if (
                              oneCandidateData &&
                              oneCandidateData.moderated === 0
                            ) {
                              setDeleteModalMessage(
                                "Вы хотите удалить кандидата?"
                              );
                              setDeleteCandidateModal(true);
                            }
                          }}
                        >
                          <img alt="" src={trash} />
                        </button>
                        <button
                          type="button"
                          className="candidate-form-btn candidate-form-btn_save"
                          disabled={
                            isCandidateAdded
                              ? isSubmitting ||
                              errorAddition ||
                              hasBackendErrors ||
                              !areMainFieldsFilled ||
                              !isValid
                              : (!dirty && !filesBtnsTouched) ||
                              isSubmitting ||
                              errorAddition ||
                              hasBackendErrors ||
                              !areMainFieldsFilled ||
                              !isValid
                          }
                          onClick={async () => {
                            if (path.includes("allvacancies")) {
                              const vacancyId = window.location.pathname.slice(
                                path.lastIndexOf("/") + 1
                              );
                              getCandidatesForVacancy({
                                on_page: 10000,
                                page: 1,
                                vacancy: vacancyId
                              });
                            }
                            if (oneCandidateData && oneCandidateData.id) {
                              const ok = await refreshUserDataCandidate({
                                ...values,
                                id: oneCandidateData.id,
                                close: true
                              });
                              if (ok) setIsCandidateModalOpen(false);
                            } else {
                              const ok = await addCandidateMinimal(values);
                              if (ok) setIsCandidateModalOpen(false);
                            }
                            setFilesBtnsTouched(false);
                            setIsNewCandidate(false);
                            isCandidateAdded && setIsCandidateAdded(false);
                          }}
                        >
                          Сохранить и закрыть
                        </button>
                        <button
                          type="button"
                          className="candidate-form-btn candidate-form-btn_apply"
                          disabled={
                            (!dirty && !filesBtnsTouched) ||
                            !isValid ||
                            isDisabled ||
                            errorAddition ||
                            hasBackendErrors ||
                            !areMainFieldsFilled
                          }
                          onClick={async () => {
                            if (
                              oneCandidateData &&
                              oneCandidateData.vacancies_candidate_id_bring_data &&
                              oneCandidateData.vacancies_candidate_id_bring_data !==
                              "0"
                            ) {
                              // Отправка на проверку
                              await refreshUserDataCandidate({
                                ...values,
                                id: oneCandidateData.id,
                                close: true
                              });
                              await refreshCandidateOnVacancy({
                                vacancy_candidate_id:
                                  oneCandidateData.vacancies_candidate_id_bring_data
                              });
                              getCandidates();
                              setSelectedCandidate("");
                              clearErrors();
                            } else {
                              // Отклик
                              if (oneCandidateData) {
                                setSelectedCandidate(oneCandidateData.id);
                                await refreshUserDataCandidate({
                                  ...values,
                                  id: oneCandidateData.id,
                                  close: true
                                });
                                await getVacancies_for_candidate(
                                  oneCandidateData.id
                                );
                                await getApplicationsForCandidate({
                                  candidate_id: oneCandidateData.id
                                });
                                setModalShowVacancies(true);
                                clearErrors();
                              }
                            }
                            isCandidateAdded && setIsCandidateAdded(false);
                          }}
                        >
                          {oneCandidateData &&
                            oneCandidateData.vacancies_candidate_id_bring_data &&
                            oneCandidateData.vacancies_candidate_id_bring_data !==
                            "0" &&
                            statusesTitles &&
                            statusesTitles[oneCandidateData.status_id] !==
                            "Черновик"
                            ? "Отправить на проверку"
                            : "Откликнуться на вакансию"}
                        </button>

                        {applyDisabled && applyDisabled.comment ? (
                          <div className="tooltip-disabled-apply">
                            <p className="m-0">
                              {applyDisabled.comment.charAt(0).match(/д/i)
                                ? "Нет возможности откликнуться кандидатом в статусе Черновик"
                                : applyDisabled.comment}
                            </p>
                          </div>
                        ) : null}
                      </div>
                    </Form>
                  </div>
                </Modal.Body>
              </Modal>
            </>
          );
        }}
      </Formik>
      <ShowDocument
        show={openModalDocument}
        onHide={() => setOpenModalDocument(false)}
        plugnodoc="Согласие на обработку персональных данных"
      />
      <FileUploadErrorModal
        show={fileUploadErrorModal}
        onHide={() => setFileUploadErrorModal(false)}
      />
    </>
  );
};

export default inject(
  ({ candidatesStore, modalWindows, filesStore, vacanciesStore }) => {
    const {
      errorAddition,
      errorAdditionFields,
      clearErrorAdditionField,
      addCandidateMinimal,
      isNewCandidate,
      selectedCandidate,
      oneCandidateData,
      oneCandidateFiles,
      setIsNewCandidate,
      setSelectedCandidate,
      refreshUserDataCandidate,
      statusesTitles,
      refreshCandidateOnVacancy,
      addOneCandidateDataValue,
      getCandidates,
      getApplicationsForCandidate,
      getCandidatesForVacancy,
      getInitialValues,
      requiredFieldsForAdd,
      requiredFieldsForUpdate,
      requiredFiles,
      setOneCandidateFile
    } = candidatesStore;

    const {
      setFileUploadErrorModal,
      fileUploadErrorModal,
      setDeleteCandidateModal,
      setIsCandidateModalOpen,
      setDeleteModalMessage,
      setModalShowVacancies,
      setFunc
    } = modalWindows;

    const { sendFile, setDocumentUrl, deleteFile } = filesStore;

    const { getVacancies_for_candidate } = vacanciesStore;

    return {
      errorAddition,
      errorAdditionFields,
      clearErrorAdditionField,

      setFileUploadErrorModal,
      fileUploadErrorModal,

      sendFile,
      deleteFile,
      addCandidateMinimal,
      isNewCandidate,
      selectedCandidate,
      setSelectedCandidate,

      oneCandidateData,
      oneCandidateFiles,
      setOneCandidateFile,
      setIsNewCandidate,
      setDeleteCandidateModal,
      refreshUserDataCandidate,
      setDocumentUrl,
      statusesTitles,
      refreshCandidateOnVacancy,
      addOneCandidateDataValue,
      setIsCandidateModalOpen,
      getCandidates,
      setDeleteModalMessage,
      getInitialValues,
      requiredFieldsForAdd,
      requiredFieldsForUpdate,
      requiredFiles,

      getApplicationsForCandidate,
      getVacancies_for_candidate,
      setModalShowVacancies,
      setFunc,

      getCandidatesForVacancy
    };
  }
)(observer(CandidateForm));
